import type { LearnChapter } from '../../services/learnService';

/** Index of the chapter playing at `seconds`, or -1 before the first one. */
export function chapterIndexAt(
  chapters: LearnChapter[],
  seconds: number
): number {
  let index = -1;
  chapters.forEach((c, i) => {
    if (c.at <= seconds) index = i;
  });
  return index;
}

/** 0:00, 12:05, 1:52:10 — the way a chapter list reads. */
export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = h ? String(m).padStart(2, '0') : String(m);
  return `${h ? `${h}:` : ''}${mm}:${String(sec).padStart(2, '0')}`;
}
